/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePimSupplierImportationsMutationVariables = Types.Exact<{
  input: Types.DeletePimSupplierImportationsInput;
}>;


export type DeletePimSupplierImportationsMutation = { deletePimSupplierImportations: { __typename: 'DeletePimSupplierImportationsResult', importations: Array<{ __typename: 'PimImportation', id: string, url: string, status: Types.PimImportationStatus, filename: string }> } };


export const DeletePimSupplierImportationsDocument = gql`
    mutation DeletePimSupplierImportations($input: DeletePimSupplierImportationsInput!) {
  deletePimSupplierImportations(input: $input) {
    importations {
      id
      url
      status
      filename
    }
  }
}
    `;
export type DeletePimSupplierImportationsMutationFn = Apollo.MutationFunction<DeletePimSupplierImportationsMutation, DeletePimSupplierImportationsMutationVariables>;

/**
 * __useDeletePimSupplierImportationsMutation__
 *
 * To run a mutation, you first call `useDeletePimSupplierImportationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePimSupplierImportationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePimSupplierImportationsMutation, { data, loading, error }] = useDeletePimSupplierImportationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePimSupplierImportationsMutation(baseOptions?: Apollo.MutationHookOptions<DeletePimSupplierImportationsMutation, DeletePimSupplierImportationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePimSupplierImportationsMutation, DeletePimSupplierImportationsMutationVariables>(DeletePimSupplierImportationsDocument, options);
      }
export type DeletePimSupplierImportationsMutationHookResult = ReturnType<typeof useDeletePimSupplierImportationsMutation>;
export type DeletePimSupplierImportationsMutationResult = Apollo.MutationResult<DeletePimSupplierImportationsMutation>;
export type DeletePimSupplierImportationsMutationOptions = Apollo.BaseMutationOptions<DeletePimSupplierImportationsMutation, DeletePimSupplierImportationsMutationVariables>;